import { Message } from "element-plus";
import { Auth } from "vue-auth3";
import { dialogMixins, DialogType, NotificationMethod } from "@/mixins/dialog";
import { formattingMixins } from "@/mixins/formatting";

interface IErrorLogOptions {
  axios: any;
  vue: any;
  auth: Auth;
}

export default class ErrorLog {
  static baseUrl: string;
  static vue: any;
  static axios: any;

  static init(options: IErrorLogOptions) {
    if (!options.axios || !options.vue) {
      return;
    }

    ErrorLog.axios = options.axios;

    // Add a response interceptor
    ErrorLog.axios.interceptors.response.use(
      function (response: any) {
        if (
          response.headers &&
          response.headers["response-message-text"] &&
          !(response.config.silentResponseMessage === true)
        ) {
          dialogMixins.showAdaptiveMessage(
            decodeURIComponent(escape(window.atob(response.headers["response-message-text"]))),
            formattingMixins.toLowerFirstChar(response.headers["response-message-dialog-type"]) as DialogType,
            formattingMixins.toLowerFirstChar(
              response.headers["response-message-notification-method"]
            ) as NotificationMethod
          );
        }
        return response;
      },
      function (error: any) {
        const statusCode = error.response ? error.response.status : "";

        if (statusCode == 401) {
          options.auth.fetch().catch(() =>
            options.auth.logout({
              makeRequest: false,
              redirect: "/login",
            })
          );
        }

        if (!error.config.silentResponseMessage) {
          if (error.response && error.response.data?.displayMessage) {
            dialogMixins.showAdaptiveMessage(
              error.response.data.displayMessage.text,
              error.response.data.displayMessage.dialogType,
              error.response.data.displayMessage.notificationMethod
            );
          } else if (error.response.data.errors) {
            error.config.silentResponseMessage = true;

            const errors = error.response.data.errors;
            const errorText =
              typeof errors === "string"
                ? errors
                : Object.values(errors).flat(Infinity).sort().reverse().join("\n");

            dialogMixins.showAdaptiveMessage(errorText, DialogType.error, NotificationMethod.message);
          }
        }
        return Promise.reject(error);
      }
    );

    ErrorLog.baseUrl = options.axios.defaults.baseURL;
    ErrorLog.vue = options.vue;
    ErrorLog.vue.config.errorHandler = (error: Error, vm: any, info: string) => {
      console.error(error, info);
      if (error) {
        try {
          ErrorLog.axios.post(`/api/report-error`, null, {
            params: {
              error,
            },
          });
        } catch (err) {
          console.error({ message: error.toString() });
        }
      }
    };

    ErrorLog.vue.config.warnHandler = (message: Message, vm: any, info: string) => {
      //console.warn(message, info);
    };

    // General JS (non-Vue) error handler
    window.onerror = function (message, source, lineno, colno, error) {
      if (error) {
        console.error({ message: error.toString() });
        try {
          ErrorLog.axios.post(`/api/report-error`, null, {
            params: {
              error,
            },
          });
        } catch (err) {
          console.error({ message: error.toString() });
        }
      }

      return true;
    };

    // Handle promise rejections
    window.onunhandledrejection = function (errorEvent) {
      // event.promise contains the promise object
      // event.reason contains the reason for the rejection
      //throw new Error(errorEvent.reason); // this converts promise rejection to ordinary JS error
    };
  }
}
